import React from 'react';

import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { useRecordContext } from 'react-admin';
import { Commission } from 'types/embedded/commission';

import { MerchantShowCommissionsForm } from '../components/MerchantShowCommissionsForm/MerchantShowCommissionsForm';
import { MerchantShowCommissionsFormSkeleton } from '../components/MerchantShowCommissionsForm/MerchantShowCommissionsFormSkeleton';

type MerchantShowCommissionsEditDialogFormProps = {
  errors: string[];
  merchantId: string | undefined;
};

export const MerchantShowCommissionsEditDialogForm = ({
  errors,
  merchantId,
}: MerchantShowCommissionsEditDialogFormProps) => {
  const record = useRecordContext<Commission>();
  const { ready } = useNormalizeReferences({
    referenceFields: ['currency', 'provider', 'calculationMethod'],
    externalRecord: record,
  });

  if (!ready) {
    return <MerchantShowCommissionsFormSkeleton />;
  }

  return <MerchantShowCommissionsForm errors={errors} merchantId={merchantId} />;
};
